import React from 'react';
import './Nodes.scss';
import { quizLoad, quizSetName, quizSetId } from '../../Quiz/quizSlice.js';
import {showTroubles, showView, setPreviousModule, getInitialStateWithPreviousView } from '../../../Menu/MenuSide/menuSideSlice.js';
import { addFavoriteQuizes, deleteFavoriteQuizes } from '../../../Authorization/authSlice';
import { setSelectedNoteId, setSelectedNoteName, setSelectedCategory, setSelectedSubCategory,
    setSelectedNotePrivateStatus} from '../../Notes/noteslice.js';
import { idNoteLoad } from '../../../Admin/adminSlice.js';
import { setUserIdFromAuth } from '../../Quiz/quizSlice.js';



export default class Nodes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            //countNodes:[],
           
        }
        
        this.showNodes = this.showNodes.bind(this);
        this.onShowQuiz=this.onShowQuiz.bind(this);
        this.onAddFavoriteQuiz = this.onAddFavoriteQuiz.bind(this);
        this.onShowTroubles = this.onShowTroubles.bind(this);
        this.onShowNotes = this.onShowNotes.bind(this);
      
    }

  

    //REDUX SHOW QUIZ - EXPAND NODES
    onShowQuiz(e) {
       const {dispatch} = this.props;
        let expanded = !this.state.expanded;
        console.log(this.props.element);

        // set selected category and subcategory
        if (this.props.element.id_category === undefined) {
            dispatch(setSelectedCategory(this.props.element.label));
        } else if (!this.props.element.marker) {
            dispatch(setSelectedSubCategory(this.props.element.label));
            dispatch(setSelectedNotePrivateStatus(this.props.statusNote));
        }   

        if (!this.props.element.nodes) {
             const id = e.target.value;
             const label = this.props.element.label; // name of the quiz
             //console.log(this.props.element.label);
            dispatch(quizSetName(label));
            dispatch(quizLoad(id));
            dispatch(quizSetId(id));
           // dispatch(closeCategoryView());
            dispatch(getInitialStateWithPreviousView());
            dispatch(setPreviousModule());
            dispatch(showView("3"));
            dispatch(setUserIdFromAuth(this.props.authData.id));

           
        } else {
            this.setState({
                expanded: expanded
            })
           
        }
    }

   
//SHOW NODES
    showNodes() {
        let arrayNodes = [];
       // console.log(arrayNodes);
       const { dispatch } = this.props;
       

        


        if (this.props.element.nodes ) {

        


        //print nodes 
            this.props.element.nodes.map((element, index) => (
                arrayNodes.push(
                <Nodes 
                key={index} 
                element={element} 
                quizViewChangeRedux={this.props.quizViewChangeRedux}
                dispatch={dispatch}
                favoritesQuizes={this.props.favoritesQuizes}
                userId={this.props.userId}
                statusNote={this.props.statusNote}
                authData={this.props.authData}    
                />)
            ));
            }
            return arrayNodes;
        }
// ADD FAVORITE SIGN 

onFavorites() {
    const favoriteQuizes =this.props.favoritesQuizes;
    // console.log(favoriteQuizes);
    // console.log('WORK');
    const id = this.props.element.id;
    //console.log(id);

    let result = false;
      
    favoriteQuizes.map(item => {
        if (item.quiz_id === id) {
           // console.log(item.quiz_id +' rrrr'+ id);
             result = true;
            
        } 
        return result;
     })
     
    return result;
}
// ADD FAVORITE QUIZ

onAddFavoriteQuiz(e) {
    const { dispatch } = this.props;
    const result = e.target.value;
    console.log(result);

    const item = {
        user_id:this.props.userId,
        quiz_id:this.props.element.id
    }
 
  if(result === "favorites") { 
    dispatch(addFavoriteQuizes(item));
   
} else { 
  
    dispatch(deleteFavoriteQuizes(item))} ;
}
//SHOW TROUBLES FOR QUIZ
onShowTroubles() {
    const { dispatch } = this.props;
    console.log('WORK SHOW TROUBLES')
    dispatch(showTroubles());
}
//SHOW NOTES FOR QUIZ
async onShowNotes(e) {
    const { dispatch } = this.props;


    const selectedNoteId = e.target.value;
    //console.log(selectedNoteId);
//get all info element in node component!!!
    //console.log(this.props.element);
    
    //console.log('WORK SHOW TROUBLES')
    
    dispatch(setSelectedNoteId(selectedNoteId));
    dispatch(setSelectedNoteName(this.props.element.label));
    dispatch(idNoteLoad(selectedNoteId));
    dispatch(getInitialStateWithPreviousView());
    dispatch(setPreviousModule());
    dispatch(showView("33"));
    
     // dispatch(showNotes());
    //dispatch(closeCategoryView());
    
    

}


 //RENDER BUTTON
     renderButton() {
        
       
       //  console.log(this.props.element.marker);
         const sign = this.props.element.nodes;
         

         //console.log(sign);
         //console.log(this.props.menuSide);

//CHANGE COLOR OF THE BUTTON
         let styleButton;
  
         if (this.state.expanded) {
             styleButton ={
                backgroundColor:"#018DD8",
                color: "white",
               // textDecoration: "underline",
               
            } 
           // styleCount = {
           //     color: "white",
          //  }
         }

//onFAVORITE 

         let styleButtonFavorites;
         const marker = this.props.element.marker; // FOR SHOW ONLY FOR QUIZ, SEE MENUSIDESLICE
         if (marker ) {
         let result = this.onFavorites();
        
        // console.log(result);
         if (result) {
            styleButtonFavorites = "onfavorites";
         } else {
            styleButtonFavorites = "favorites";
         }
        } 
         

//RENDER body BUTTON
         if (sign) {
     // COUNT NODES
        let nodesLength = this.props.element.nodes.length;
       
        //ARRAY OF LENGTH SUB DATA NODES
        let b;
         b = sign.map(array => {
           
            let count;
            if (array.nodes) {
            count = array.nodes.length;
            
            return count;
            } else
            return null;
         });
         // SUM ARRAY OF LENFTH SUB DATA NODES
         const sum1 = b.reduce((partialSum, a) => partialSum + a, 0);

         //SHOW COUNT ONLY IN IF EXIST
         const sum2 = (sum1 !== 0) ? sum1 :null;
         //console.log(b);

         // SHOW COUNT
         const count = 
         <sub className={this.state.expanded ? "count-selected" : "count"}>
        {nodesLength}{sum2 ? "/" : ""}{sum2}
         </sub>;
         const publisherItem = <p className={this.state.expanded ? "pub-selected" : "pub"}>{this.props.element.publisher}</p>

     //RENDER BUTTONS NODES
    /*                 <button 
                           style={styleButton}
                            type="button"
                            onClick={this.onShowQuiz}
                            id={"category"+this.props.element.id+this.props.element.id_category }
                           
                        >+ {this.props.element.label}{count}{publisherItem} </button>*/
     /*
     <button     
                            className={!this.state.expanded ? 'category_'+ this.props.element.id: 'category_' + this.props.element.id + '-selected' + ' ' + 'style-selected'  }
                            type="button"
                            onClick={this.onShowQuiz}
                           
                        >+ {this.props.element.label}{count}{publisherItem} </button>
   */                                            
         return(
            
                <button 
                           style={styleButton}
                            type="button"
                            onClick={this.onShowQuiz}
                            id={!this.state.expanded ? "category"+this.props.element.id+this.props.element.id_category : "category"+this.props.element.id+this.props.element.id_category+'-selected' }
                           
                        >+ {this.props.element.label}{count}{publisherItem} </button>
               
             
         ) 
         } else {
            return(
            <div className="quiz_button">
                <div className='button-1row'>
                    <button 
                        className='quiz' 
                        type="button"
                        onClick={this.onShowQuiz}
                        value={this.props.element.id}
                    
                    > - {this.props.element.id}. {this.props.element.label}</button>
                </div>
                <div className='button-2row'>
                    <p className='publisher'>{this.props.element.publisher} </p>
                    
                    <button className={styleButtonFavorites} value ={styleButtonFavorites} onClick={this.onAddFavoriteQuiz}></button>
                    <button className="note" value={this.props.element.id} onClick={this.onShowNotes}></button>
                    {(this.props.authData.modulesName[1].status || (this.props.authData.userRole[0].role_id === 1)) ? <button className="trouble" onClick={this.onShowTroubles}></button> : null}
                    
                    
                    
                    {/*<div className="unlocked" ></div>*/}
                </div>

            </div>
             )   
         }
     }   
    

    //RENDER NODE
    render() {
 
        return (
            
            <div className="Nodes-container">
           
                <div className="Nodes ">
                {this.renderButton()}
                {/*this.favoriteQuizesTrue()*/}
                {this.state.expanded && <div className="Nodes-container-child"> {this.showNodes()} </div>}
                </div>

            </div>
            
        );
    }

    
}